import React from 'react';
import { Card, CardBody, CardTitle } from 'reactstrap';

import SlackLogo from '../assets/img/slack-logo.svg';
import TeamsLogo from '../assets/img/teams-logo.svg';

class TeamInfo extends React.Component {
  render() {
    const profile = this.props.profile;
    const platform = profile.platform || 'slack';

    const platformIcon = platform === 'teams'
      ? <img src={TeamsLogo} alt="Teams" className="platform-icon" />
      : <img src={SlackLogo} alt="Slack" className="platform-icon" />;

    const users = profile.admin
      ? <><br />Active Users: <strong>{profile.users}</strong></>
      : <></>;

    return (
      <>
        <Card className="shadow team-info">
          <CardBody>
            <CardTitle>
              <h5>Team Info</h5>
            </CardTitle>
            <div className="paragraph">
              Team: <strong>{profile.tname || 'Personal Account'}</strong> {platformIcon}<br />
              Team ID: <strong>{profile.team}</strong>
              {users}
            </div>
          </CardBody>
        </Card>
      </>
    );
  }
}

export default TeamInfo;
